module.exports = __webpack_public_path__ + "img/businessManager.ec6ae320.png";